import React from "react";
import { Table, Button, Alert } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";

const EquipmentList = ({ equipments, onEdit, onDelete, loading, t }) => {
    console.log("EquipmentList rendering with equipments:", equipments);

    if (!equipments || equipments.length === 0) {
        console.log("No equipment records found, showing empty message");
        return (
            <Alert variant="info" className="text-center">
                {t('noEquipmentRecords') || "No equipment records found."}
            </Alert>
        );
    }

    // If we get here, we have equipment to display
    console.log("Rendering equipment table with data:", equipments);
    return (
        <Table striped bordered hover responsive className="mt-4">
            <thead>
            <tr>
                <th>{t('category')}</th>
                <th>{t('make')}</th>
                <th>{t('model')}</th>
                <th>{t('serialNumber')}</th>
                <th>{t('status')}</th>
                <th>{t('dateAssigned')}</th>
                <th>{t('actions')}</th>
            </tr>
            </thead>
            <tbody>
            {equipments.map((equipment, index) => (
                <tr key={equipment.id || index}>
                    <td>{equipment.category}</td>
                    <td>{equipment.make}</td>
                    <td>{equipment.model}</td>
                    <td>{equipment.serial_number}</td>
                    <td>{equipment.status_of_equipment}</td>
                    <td>{equipment.date_assigned}</td>
                    <td>
                        <Button
                            variant="warning"
                            size="sm"
                            className="me-1"
                            onClick={() => onEdit(index)}
                            disabled={loading}
                        >
                            <FaEdit />
                        </Button>
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => onDelete(index)}
                            disabled={loading}
                        >
                            <FaTrash />
                        </Button>
                    </td>
                </tr>
            ))}
            </tbody>
        </Table>
    );
};

export default EquipmentList;